var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kindTheme === 0 || _vm.kindTheme === 2)?_c('SearchResultTheme0'):(_vm.kindTheme===1)?_c('SearchResultTheme1'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }